// DycRouteSettingConfig.jsx
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";

const DycRouteSettingConfig = ({ routeLayout, protectRoute, routeList }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isFlat = !routeLayout || routeLayout?.type === React.Fragment;

  return (
    <Routes>
      {isFlat ? (
        <>
          {routeList.map((route, idx) => {
            // support index routes
            if (route.index) return <Route key={idx} index element={route.element} />;
            return <Route key={idx} path={route.path} element={route.element} />;
          })}
          <Route path="*" element={<></>} />
        </>
      ) : (
        // 🔧 PATHLESS layout route (no `path` prop)
        <Route
          element={protectRoute ? <ProtectedRoutes>{routeLayout}</ProtectedRoutes> : routeLayout}
        >
          {routeList.map((route, idx) => {
            if (route.index) return <Route key={idx} index element={route.element} />;
            return <Route key={idx} path={route.path} element={route.element} />;
          })}
          {/* no wildcard here that could swallow public routes */}
        </Route>
      )}
    </Routes>
  );
};

export default DycRouteSettingConfig;
